import { render, staticRenderFns } from "./TrueAdviceFire.vue?vue&type=template&id=77485f68&"
import script from "./TrueAdviceFire.vue?vue&type=script&lang=js&"
export * from "./TrueAdviceFire.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports